// BannerFour.js
import React, { useState } from "react";
// Short lead form to capture rapidement des prospects
import OwnerLeadForm from "../contact/OwnerLeadForm";
import BrandItemNew from "../brand/BrandItemNew";
import CardIconList from "../card/CardIconList";

const IntroAndTrigger = () => {
  const [showForm, setShowForm] = useState(false);

  const handleStart = () => {
    setShowForm(true);
    setTimeout(() => {
      const first = document.getElementById("propertyType");
      if (first) first.focus();
    }, 300);
  };

  return (
    <>
      {!showForm && (
        <div>
          <div className="owner-intro">
            <h3>Estimation gratuite</h3>
            <p className="description">
              Nous évaluons rapidement le potentiel de votre bien et vous proposons un bail professionnel avec loyer garanti. Remplissez ce formulaire en moins d'une minute.
            </p>
            <div className="benefits">
              <div className="benefit-item">
                <span className="check">✓</span>
                <span>Versement mensuel garanti</span>
              </div>
              <div className="benefit-item">
                <span className="check">✓</span>
                <span>Gestion clé en main (locataire, paiements, entretien)</span>
              </div>
              <div className="benefit-item">
                <span className="check">✓</span>
                <span>Pas de frais cachés — bail sécurisé</span>
              </div>
            </div>
            <button className="estimate-btn" onClick={handleStart}>
              Proposer mon logement
            </button>
          </div>
        </div>
      )}

      {showForm && (
        <div>
          <OwnerLeadForm />
        </div>
      )}
    </>
  );
};

const BannerFour = () => {
  return (
    <div className="banner banner-style-6" style={{ height: "100%" }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-xl-7">
            <div className="banner-content">

              {/* Titre accrocheur pour les propriétaires */}
              <h1 className="title">
                Confiez votre{" "}
                <span className="highlight">logement</span> à un{" "}
                <span className="highlight">locataire professionnel</span> et percevez un{" "}
                <span className="highlight">loyer garanti</span> chaque mois.
              </h1>

              {/* Description qui explique la prestation */}
              <p className="description mt--20">
                Nous devenons votre locataire de référence : signature d’un bail professionnel,
                sélection de locataires triés sur le volet, gestion 100 % clé en main (paiements,
                entretien, assurance). Vous profitez de revenus stables sans les soucis de la
                gestion locative.
              </p>

              {/* CTA principal déplacé vers la colonne formulaire pour conserver la hiérarchie */}
              <CardIconList />
            </div>
          </div>

          {/* Formulaire / image: remplaçé par un formulaire court pour maximiser les conversions */}
          <div id="test" className="col-lg-6 col-xl-5">
            <div className="bg-white contact-form-box shadow-box">
              {/* Introduction marketing / SEO — première étape avant le formulaire */}
              <IntroAndTrigger />
            </div>
          </div>
        </div>
      </div>
      <ul className="list-unstyled shape-group-19">
        <li className="shape shape-1">
          <img
            src={process.env.PUBLIC_URL + "/images/others/bubble-29.png"}
            alt="Bubble"
          />
        </li>
        <li className="shape shape-2">
          <img
            src={process.env.PUBLIC_URL + "/images/others/line-7.png"}
            alt="Bubble"
          />
        </li>
      </ul>
      <BrandItemNew mediaWith={"992"} />
    </div>
  );
};

export default BannerFour;
